import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Role } from '@lov/shared';
import type { User } from '@lov/shared';
import { apiClient } from '../../lib/api/client';

export function GoogleCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { updateUser } = useAuth();

  useEffect(() => {
    const userParam = searchParams.get('user');
    if (userParam) {
      try {
        const userData = JSON.parse(atob(userParam)) as User;
        // Tokens are already in httpOnly cookies set by the backend redirect.
        // We only need to store user data in context/localStorage for UI state.
        updateUser(userData);

        // Role-based redirect
        const redirect = async () => {
          switch (userData.role) {
            case Role.SUPER_ADMIN:
              navigate('/admin/dashboard', { replace: true });
              break;
            case Role.VENDOR:
            case Role.VENDOR_STAFF:
              // Check if vendor user has a vendor entity
              try {
                const vendorResponse = await apiClient.get<{ id: string } | null>('/vendors/me');
                if (!vendorResponse.data) {
                  // No vendor entity - redirect to home
                  navigate('/', { replace: true });
                } else {
                  // Has vendor entity - go to dashboard
                  navigate('/vendor/dashboard', { replace: true });
                }
              } catch {
                // On error, default to dashboard (it will handle the redirect)
                navigate('/vendor/dashboard', { replace: true });
              }
              break;
            case Role.CUSTOMER:
            default:
              navigate('/dashboard', { replace: true });
              break;
          }
        };

        redirect();
        return;
      } catch (e) {
        console.error('Failed to parse user data from Google callback', e);
      }
    }
    navigate('/', { replace: true });
  }, [searchParams, updateUser, navigate]);

  return <div>Signing you in...</div>;
}
